module.exports = __webpack_public_path__ + "static/glow-effect-2-de69594b46ef792d5f87a654925772e1.png";